export class SponsorInformation {
    firstName: string;
    lastName: string;
    fboId: string;
    emailId: string;
    mobile: string;  
    memberLevelID: number;
}


// WEBPACK FOOTER //
// ./src/app/customerservice/interface/sponsor-information.ts